export const BASE_QUERY_KEYS = {
  infiniteList: 'infinite-list',
  items: 'items',
  item: 'item',
  list: 'list',
  composed: 'composed',
  my: 'my',
};

export enum DataCacheType {
  Live = 'live',
  Snapshot = 'snapshot',
}
